export default __webpack_public_path__ + "static/media/HP-prisoner-of-azkaban.00dd6eb6.jpg";